import { useMemo } from 'react';
import { ROLES, getRoleName, getRoleNameEn, canPerformAction } from '@shared/types';

export interface UserRoleInfo {
  roleId: number | undefined;
  isTeacher: boolean;
  isStudent: boolean;
  isAdmin: boolean;
  isPrincipal: boolean;
  roleName: string;
  roleNameEn: string;
  canEditProfile: boolean;
  canAccessAdmin: boolean;
  canManageClasses: boolean;
  canViewGrades: boolean;
  avatarType: 'teacher' | 'student' | 'admin';
  // פונקציות עזר נוספות
  canPerformAction: (action: keyof typeof import('@shared/types').PERMISSIONS) => boolean;
  getAvatarType: () => 'teacher' | 'student' | 'admin';
}

export function useUserRole(userRoleId: number | undefined): UserRoleInfo {
  return useMemo(() => {
    const isTeacher = userRoleId === ROLES.TEACHER;
    const isStudent = userRoleId === ROLES.STUDENT;
    const isAdmin = userRoleId === ROLES.ADMIN;
    const isPrincipal = userRoleId === ROLES.PRINCIPAL;

    const getAvatarType = (): 'teacher' | 'student' | 'admin' => {
      if (isTeacher) return 'teacher';
      if (isAdmin || isPrincipal) return 'admin';
      return 'student';
    };

    return {
      roleId: userRoleId,
      isTeacher,
      isStudent,
      isAdmin,
      isPrincipal,
      roleName: getRoleName(userRoleId || 0),
      roleNameEn: getRoleNameEn(userRoleId || 0),
      canEditProfile: isTeacher || isAdmin || isPrincipal,
      canAccessAdmin: isAdmin || isPrincipal,
      canManageClasses: isTeacher || isAdmin || isPrincipal,
      canViewGrades: isStudent || isTeacher || isAdmin || isPrincipal,
      avatarType: getAvatarType(),
      canPerformAction: (action) => canPerformAction(userRoleId, action),
      getAvatarType,
    };
  }, [userRoleId]);
}
